import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Edit2 } from 'iconsax-react';
import { useProfileCreationFormContext } from '../../ProfileCreationFormProvider';

import CompanyInfo from '../CompanyInfo/CompanyInfo';
import Catalogue from '../Catalogue/Catalogue';
import Category from '../Category/Category';
import AwardsAndCertificates from '../AwardsAndCertificates/AwardsAndCertificates';
import BranchesAndWarehouses from '../BranchesAndWarehouses/BranchesAndWarehouses';
import TitleText from '../../../atoms/TitleText';
import InfoText from '../../../atoms/InfoText';
import CustomModal from '../../../atoms/CustomModal';

export default function ProfileReview() {
  const { t } = useTranslation();
  const [isCompanyInfoModalOpen, setIsCompanyInfoModalOpen] = useState(false);
  const [companyInfoRefreshKey, setCompanyInfoRefreshKey] = useState(0);
  const { setModalOpen } = useProfileCreationFormContext();

  useEffect(() => {
    setModalOpen(isCompanyInfoModalOpen);
  }, [isCompanyInfoModalOpen, setModalOpen]);

  return (
    <div className="flex flex-col gap-8 pb-11 max-w-[976px] w-full mx-auto" data-testid="profile-creation-review-container">
      <div className="flex justify-between items-center" data-testid="profile-creation-review-header">
        <div className="flex flex-col gap-1">
          <TitleText size="2xl" text={t('components.personalInformation')} className="font-semibold" />
          <InfoText text={t('components.personalInfoDesc')} className="text-gray-500 dark:text-dark-text-secondary text-sm" />
        </div>
        <div
          onClick={() => setIsCompanyInfoModalOpen(true)}
          className="bg-blue-50 dark:bg-dark-surface-secondary text-blue-500 dark:text-blue-400 p-2 w-8 h-8 rounded-full flex justify-center items-center cursor-pointer hover:scale-105 transition-all"
          data-testid="profile-creation-edit-step-0-button"
        >
          <Edit2 variant="Bold" size={16} />
        </div>
      </div>

      <CustomModal
        open={isCompanyInfoModalOpen}
        onCancel={() => setIsCompanyInfoModalOpen(false)}
        title={t('components.editPersonalInformation')}
        subTitle={t('components.editPersonalInfoModalDesc')}
        centered
      >
        {isCompanyInfoModalOpen && (
          <CompanyInfo
            isReview={true}
            disableSubmitRegistration
            onSuccess={() => {
              setIsCompanyInfoModalOpen(false);
              setCompanyInfoRefreshKey((prev) => prev + 1);
            }}
          />
        )}
      </CustomModal>

      <div className="flex flex-col gap-6">
        <div data-testid="profile-creation-review-step-company-info">
          <CompanyInfo isReview key={companyInfoRefreshKey} />
        </div>
        <div data-testid="profile-creation-review-step-catalogue">
          <Catalogue isReview />
        </div>
        <div data-testid="profile-creation-review-step-category">
          <Category isReview />
        </div>
        <div data-testid="profile-creation-review-step-awards">
          <AwardsAndCertificates />
        </div>
        <div data-testid="profile-creation-review-step-branches">
          <BranchesAndWarehouses />
        </div>
      </div>
    </div>
  );
}
